import serviceRequest from "utils/request";

const baseUrl = "/api/e-course";

export const videoRecord = (params) => {
	return serviceRequest({
		url: `${baseUrl}/record`,
		method: "get",
		params,
	});
};

export const getResearcherCourseList = (data) => {
	return serviceRequest({
		url: `${baseUrl}/get-researcher-course-list`,
		method: "post",
		data,
	});
};

export const getAdminCourseList = (data) => {
	return serviceRequest({
		url: `${baseUrl}/get-course-list`,
		method: "post",
		data,
	});
};

export const editCourse = (data) => {
	return serviceRequest({
		url: `${baseUrl}/edit`,
		method: "post",
		data,
	});
};

export const addCourse = (data) => {
	return serviceRequest({
		url: `${baseUrl}/add`,
		method: "post",
		data,
	});
};

export const courseDetail = (params) => {
	return serviceRequest({
		url: `${baseUrl}/detail`,
		method: "get",
		params,
	});
};

export const deleteCourse = (params) => {
	return serviceRequest({
		url: `${baseUrl}/delete`,
		method: "get",
		params,
	});
};
